export default __webpack_public_path__ + "static/media/logo.2d827c1e.png";